import { APP_INITIALIZER } from '@angular/core';
import { ThemeService } from './theme.service';

const THEME_LOAD_TIMEOUT = 5000;

export const AppInitializerProvider = {
  provide: APP_INITIALIZER,
  useFactory: (themeService: ThemeService) => () => {
    return Promise.race([
      themeService.loadTheme(),
      new Promise<void>(resolve => setTimeout(resolve, THEME_LOAD_TIMEOUT)),
    ]);
  },
  deps: [ThemeService],
  multi: true,
};
